// extracted by mini-css-extract-plugin
export default {"ant-table-thead":"referralLinks_ant-table-thead__gXxWQ","ref-link":"referralLinks_ref-link__fb-4c"};